import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'

interface UptimeBadgeProps {
  status: string
  uptime?: string
  variant?: 'running' | 'stopped' | 'default'
}

export const UptimeBadge = ({
  status,
  uptime,
  variant = 'default',
}: UptimeBadgeProps) => {
  return (
    <Badge
      variant="outline"
      className={cn(
        variant === 'running'
          ? 'bg-primary/10 text-primary'
          : variant === 'stopped'
            ? 'bg-destructive/10 text-destructive'
            : 'bg-foreground/10 text-foreground/80'
      )}
    >
      {status}
      {uptime ? ` • ${uptime}` : ''}
    </Badge>
  )
}
